import { IBgxHttpRESTOptions } from '../../';
import { BgxAbstractMethod } from './abstract-method.decorator';

/**
 * Decorator that adds PUT request capabilities to a method
 */
export function BgxPUT(config: {
  path: string;
  options?: IBgxHttpRESTOptions;
}): (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<Function>) => any {
  return BgxAbstractMethod(
    <any>Object.assign(
      {
        method: 'PUT',
      },
      config,
    ),
  );
}
